import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';

import { Mote, MoteSortType, MotesPaths, MoteType, MoteTypeIconMap } from '../../models';
import { AutoSub, AutoSubOnDestroy, EventDay, ScheduleService, ScrollToElementService, UserMoteService } from '../../providers';


@AutoSubOnDestroy()
@Component({
    selector: 'schedule-list',
    templateUrl: './schedule-list.component.html',
    styleUrls: ['./schedule-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ScheduleListComponent implements OnInit {
    /**
     * Schedule Mote key - the key of the parent mote containing Event Motes.
     * The component will fetch the list of mote children and show them in the list of events
     */
    @Input('scheduleMoteKey') set initScheduleMoteKey(scheduleKey: string) {
        this.watchMotes(scheduleKey);
    }

    /**
     * Emitted when an event Mote in from the list is clicked
     */
    @Output() eventClicked = new EventEmitter<Mote>();

    /**
     * Emit true when the content (the events) has been loaded first time 
     */
    @Output() loaded = new EventEmitter<boolean>();

    @ViewChild('eventScrollList') eventScrollList: ElementRef<HTMLDivElement>;
    @ViewChild('dayScrollList') dayScrollList: ElementRef<HTMLDivElement>;

    public eventDayList: EventDay[] = [];
    public activeEventDay: EventDay = { key: '0', label: '', date: new Date(), events: [] };

    private isListInitialized = false;

    // Expose to view
    public SQUARE_PLACEHOLDER = MotesPaths.SQUARE_PLACEHOLDER;
    public EVENT_ICON = MoteTypeIconMap[MoteType.EVENT];
    public TIME_ICON = 'clockSolid'; // MoteTypeIconMap[MoteType.EVENT];

    constructor(private scrollService: ScrollToElementService, private userMoteService: UserMoteService, private scheduleService: ScheduleService) {

    }

    ngOnInit(): void {
        this.isListInitialized = false;
    }

    private async watchMotes(scheduleKey: string) {
        let schedule = await this.userMoteService.getUserMote(scheduleKey);

        AutoSub(this).reg['eventMotesSub'] = this.userMoteService.watchMotesInCollection(scheduleKey, MoteSortType.START_DATE, schedule.project).subscribe(motes => {
            // Generate list of event days
            this.eventDayList = this.scheduleService.generateEventDayList(motes);
            // Init event day
            if(this.eventDayList.length > 0) this.activeEventDay = this.eventDayList[0];
            // Find first event which is not past
            // TODO: Figure out how to handle scroll when revisiting schedule
            // let futureEvents = this.eventDayList.filter( eventDay => !this.isEventPassed(eventDay.date));
            // if(futureEvents.length > 0 && !this.isListInitialized) {
            //     this.isListInitialized = true;
            //     this.scrollToDay(futureEvents[0]);
            // }
            this.loaded.emit(true);
        });
    }


    /**
     * Set activeEventDay (highlight it in header) when user scrolls to it in the list
     */
    public onIntersection(ev: IntersectionObserverEntry[], eventDay: EventDay) {
        if(ev.length <= 0 || !ev[0].isIntersecting) return;
        // Disable scroll to active day label for now as it dosen't make sense to usr without smooth scroll (mot supported on iOS) 
        //this.scrollToActiveDayLabel(eventDay);
        this.activeEventDay = eventDay;
    }

    /**
     * Vertically scroll to event day when label is pressed
     */
    public scrollToDay(eventDay: EventDay) {
        let scrollList = this.eventScrollList.nativeElement;
        // Scroll to first event of eventDay
        this.scrollService.scrollToElementInList(`event-day-${eventDay.key}`, scrollList, 'Vertical');
    }

    /**
     * Horizontally scroll to active day label in header (if its outside of view)
     */
    private scrollToActiveDayLabel(eventDay: EventDay) {
        let labelId = `day-label-${eventDay.key}`;
        // Scroll eventDay label into header x-scroll
        this.scrollService.scrollToElementInList(labelId, this.dayScrollList.nativeElement, 'Horizontal');
    }

    public emitEventClicked(event: Mote) {
        this.eventClicked.emit(event);
    }

    public isEventPassed(eventEnd: Date): boolean {
        return (eventEnd.getTime() < Date.now());
    }

    public trackByKey(index: number, eventDay: EventDay): string {
        return eventDay.key;
    }
}
